import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/siteData';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">
              <strong>日韩中字最新更新</strong>，追剧不等待
            </p>
          </div>
          <Link
            to="/category/drama"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group flex gap-4 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-28 h-36 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`${item.title} - ${item.titleEn} 中文字幕在线观看`}
                  title={`${item.title} ${item.categoryName}中文字幕`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                  <span className="text-white text-xs font-medium whitespace-nowrap">{item.rating}</span>
                </div>
              </div>
              <div className="flex flex-col justify-between flex-1 min-w-0">
                <div>
                  <span className="inline-block text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-md mb-2 whitespace-nowrap">
                    {item.categoryName}
                  </span>
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
                <span className="inline-flex items-center gap-1 text-xs text-accent-600 font-medium mt-2 whitespace-nowrap">
                  <i className="ri-time-line"></i>
                  {item.updateInfo}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/drama"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}